import { APP_INITIALIZER } from '@angular/core';
import { registerLocaleData } from '@angular/common';

var dscomponents = {
	login: "Login",
	logout: "Logout",
	welcome: "Welcome {0}",
	successNotification: "Success Message",
	infoNotification: "Info Message",
	warningNotification: "Warning Message",
	errorNotification: "Error Message",
	closeNotification: "Close Notification",
	close: "Close",
	clearAll: "Clear All",
	showLess: "Show Less",
	showMoreAriaLabel: "Show {0} more",
	selectedText: "{0} of {1} selected",
	previousButton: "Previous Button",
	nextButton: "Next Button",
	enterDate: "Enter Date",
	today: "Today",
	previousIcon: "Previous Icon",
	nextIcon: "Next Icon",
	invalidTime: "Not a Valid time",
	of: "of",
	removeAll: "Remove all",
	removeSelected: "Remove Selected",
	searchHere: "Search here",
	search: "Search",
	cancel: "Cancel",
	confirm: "Confirm",
	exit: "Exit",
	unsavedData: "Unsaved Data",
	selectionModalWarningMessage: "All changes will be lost. Exit without saving ?",
	apply: "Apply",
	last: "Last",
	days: "Days",
	lastTwoDays: "Last 2 Days",
	lastSevenDays: "Last 7 Days",
	currentMonth: "Current Month",
	previousMonth: "Previous Month",
	lastNdays: "Last...Days",
	clear: "Clear",
	invalidDate: "Not a valid date",
	outOfRange: "Date is out of range",
	notValidDateRange: "Not a valid date range",
	disabledDate: "Date is disabled",
	selectAvailableDate: "Select an available date",
	startDatePlaceholder: "Start Date",
	endDatePlaceholder: "End Date",
	invalidDateTime: "Not a valid date time",
	selectEndDateError: "Select end date",
	dateRangeLabel: "Enter Date Range",
	noItemsFound: "No Items Found",
	remove: "remove",
	searchSelected: "Search selected",
	noResult: "No results found",
	cannotDisplay: "Cannot load data",
	noPermission: "Permissions required",
	noCreated: "No items created yet",
	numberSelectedText: "{0} selected",
	queryChipSelectText: "Select…",
	queryAddCriteriaText: "Add Criteria",
	queryTagInputTextLimitWarning: "Enter up to {0} characters",
	queryTagLimitWarning: "Enter up to {0} {1}",
	queryTagMaxExceededNotice: "First {0} values added",
	queryTagMaxExceeded1Notice: "First value added",
	queryTagDuplicateTextNotice: "Duplications were removed",
	queryTagUnsupportedTextNotice: "Unsupported values not added",
	queryTagInputPlaceholder: "Add {0}",
	queryTagPlural: "tags",
	queryAllSelectOption: "All",
	queryAllResultsSelectOption: "All results",
	dropdownItemSelectedText: "{0} items selected",
	queryAddFilterText: "Add Filter",
	queryBuilderErrorMessage: "Each added criteria must contain at least one value",
	selectStartDateError: "Select start date",
	selectAll: "Select All",
	queryChipOperatorText: "Operator",
	enterTime: "Enter Time",
	selectTime: "select time",
	startDateTabTitle: "Start Date",
	endDateTabTitle: "End Date",
	fieldRequired: "This field is required",
	floatingMenuSuggestionTitle: "Suggested questions",
	submit: "Submit",
	upToXItems: "Up to {0} items",
	selectUpToXItems: "Select up to {0} items"
};
var strings_en_US = {
	dscomponents: dscomponents
};

var jsonStrings = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: strings_en_US,
    dscomponents: dscomponents
});

function languageInitializer() {
    return async () => {
        let langCode = navigator.language;
        try {
            const module = await import(
            /* webpackInclude: /(ar|bg|da|de|el|en|es|fi|fr|he|hu|id|is|it|ja|ko|nl|no|pl|pt|ro|ru|sv|th|tr|uk|zh|zh-HANS|zh-HANT)\.mjs$/ */
            `../../../@angular/common/locales/${langCode}.mjs`);
            registerLocaleData(module.default);
        }
        catch (e) {
            langCode = langCode.split('-')[0];
            const module = await import(
            /* webpackInclude: /(ar|bg|da|de|el|en|es|fi|fr|he|hu|id|is|it|ja|ko|nl|no|pl|pt|ro|ru|sv|th|tr|uk|zh|zh-HANS|zh-HANT)\.mjs$/ */
            `../../../@angular/common/locales/${langCode}.mjs`);
            registerLocaleData(module.default);
        }
    };
}
const languageInitializerProvider = {
    provide: APP_INITIALIZER,
    useFactory: languageInitializer,
    multi: true
};

const strings = jsonStrings;

/**
 * Generated bundle index. Do not edit.
 */

export { languageInitializer, languageInitializerProvider, strings };

